module.exports = __webpack_public_path__ + "img/logo.89af6729.png";